import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import DocumentMeta from "react-document-meta";
import registerServiceWorker from "./registerServiceWorker";

const meta = {
  title:
    "SmartConsole Extension Developer Guide - Check Point Software Technologies",
  description: "SmartConsole Extension Developer Guide",
  canonical:
    "https://sc1.checkpoint.com/documents/SmartConsole/Extensions/index.html",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "react,meta,document,html,tags"
    }
  }
};

ReactDOM.render(
  <DocumentMeta {...meta}>
    <App />
  </DocumentMeta>,
  document.getElementById("root")
);
registerServiceWorker();
